import * as actionType from '../constants/constant.action';

const defaultUiState = {
  searchText: '',
  claimType: 'ALL',
  system: 'ALL',
  status: 'ALL',
};

const defaultState = {
  loading: false,
  error: '',
  claims: [],
  loadComplete: false,
  uiState: defaultUiState,
  detailLoading: false,
  detailError: '',
  claimDetail: null,
  selectedClaim: null,
};

const claimsDetails = (state = defaultState, action) => {
  switch (action.type) {
    case actionType.CLAIMS_LOAD:
    case actionType.GET_CLAIMS_SUMMARY_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        error: '',
        loadComplete: false,
        claims: [],
      };

    case actionType.GET_CLAIMS_SUMMARY_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        loadComplete: true,
        claims: action.payload,
        error: '',
      };

    case actionType.GET_CLAIMS_SUMMARY_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        loadComplete: true,
        claims: [],
        error: action.payload || 'Failed to load claims.',
      };

    case actionType.GET_CLAIM_DETAIL_REQUEST:
      return {
        ...state,
        detailLoading: true,
        detailError: '',
        claimDetail: null,
        selectedClaim: action.payload.selectedClaim || null,
      };

    case actionType.GET_CLAIM_DETAIL_SUCCESS:
      return {
        ...state,
        detailLoading: false,
        claimDetail: action.payload,
        detailError: '',
      };

    case actionType.GET_CLAIM_DETAIL_FAILURE:
      return {
        ...state,
        detailLoading: false,
        claimDetail: null,
        detailError: action.payload || 'Failed to load claim detail.',
      };

    case actionType.CLAIMS_SET_UI_STATE:
      return {
        ...state,
        uiState: {
          ...state.uiState,
          ...action.payload,
        },
      };

    case actionType.CLAIMS_CLEAR_DETAIL:
      return {
        ...state,
        detailLoading: false,
        detailError: '',
        claimDetail: null,
        selectedClaim: null,
      };

    case actionType.CLAIMS_CLOSE:
      return defaultState;

    default:
      return state;
  }
};

export default claimsDetails;
